import React from 'react'; // 1. Se añade la importación de React
import { ReactComponent as usersIcon } from '../assets/icons/usuario.svg';
import { ReactComponent as consultaEnvasesIcon } from '../assets/icons/reporte.svg';
import { ReactComponent as audiIcon } from '../assets/icons/auditrail.svg';
import { ReactComponent as catalogIcon } from '../assets/icons/catalogos.svg';

import { IconType } from 'react-icons';

// --- Interfaces ---

export interface SubMenuItemType {
  name: string;
  path: string;
}

export interface WidgetType {
  title: string;
  // 2. Se corrige el tipo para aceptar componentes SVG y de react-icons
  icon: IconType | React.FC<React.SVGProps<SVGSVGElement>>;
  statistic: string;
  description: string;
  path: string;
  color: string;
  interactionType?: 'focus';
  subItems?: SubMenuItemType[];
  submenuPosition?: 'left' | 'right';
}

// --- Datos ---

export const widgetData: WidgetType[] = [
  {
    title: 'Usuarios',
    icon: usersIcon, // Válido
    statistic: '',
    description: 'Usuarios activos en el sistema',
    path: '/usuarios',
    color: '#007bff',
  },
  {
    title: 'Reporte de acetona',
    icon: consultaEnvasesIcon, // Válido
    statistic: '315',
    description: 'Consultas este mes',
    path: '/reporte-acetileno',
    color: '#fd7e14',
  },
  {
    title: 'Catálogos',
    icon: catalogIcon, // Válido
    statistic: '5,832',
    description: 'Registros de catalogos',
    path: '/catalogos',
    color: '#6c757d',
  },
  {
    title: 'Auditrail',
    icon: audiIcon, // Válido
    statistic: '5,832',
    description: 'Registros',
    path: '/auditrail',
    color: '#6c757d',
  },
  /*{
    title: 'Maestro envases',
    icon: consultaEnvasesIcon, // Válido
    statistic: '5,832',
    description: 'Registros',
    path: '/maestro-envases',
    color: '#6c757d',
  },
  /*
    NOTA: El siguiente código está comentado porque faltan las importaciones de los iconos.
    Para descomentarlo, necesitarías importar 'catalogoIcon', 'reportesIcon', etc.
    de la misma manera que los otros.

    {
      title: 'Catálogos',
      icon: catalogoIcon,
      statistic: '89',
      description: 'Catálogos de productos',
      path: '/dashboard/catalogos',
      color: '#6f42c1',
      interactionType: 'focus',
      subItems: [
        { name: 'Fabricante', path: '/dashboard/catalogos/productos' },
        { name: 'Marca', path: '/dashboard/catalogos/servicios' },
        { name: 'Modelo', path: '/dashboard/catalogos/proveedores' },
      ],
    },
    // ... más widgets comentados
  */
];